export const HighSchools = [
  { value: 'Alexandria High School', label: 'Alexandria High School' },
  { value: 'Anderson Preparatory Academy', label: 'Anderson Preparatory Academy' },
  { value: 'Bishop Chatard High School', label: 'Bishop Chatard High School' },
  { value: 'Bishop Dwenger High School', label: 'Bishop Dwenger High School' },
  { value: 'Cathedral High School', label: 'Cathedral High School' },
  { value: 'Carmel High School', label: 'Carmel High School' },
  { value: 'Daleville Jr/Sr High School', label: 'Daleville Jr/Sr High School' },
  { value: 'Eastern Hancock High School', label: 'Eastern Hancock High School' },
  { value: 'Flat Rock Schools', label: 'Flat Rock Schools' },
  { value: 'Greenfield-Central High School', label: 'Greenfield-Central High School' },
  { value: 'Greenwood Christian Academy', label: 'Greenwood Christian Academy' },
  { value: 'Hamilton Heights High School', label: 'Hamilton Heights High School' },
  { value: 'Hamilton Southeastern', label: 'Hamilton Southeastern' },
  { value: 'Heritage Christian', label: 'Heritage Christian' },
  { value: 'Herron High School', label: 'Herron High School' },
  { value: 'Home School', label: 'Home School' },
  { value: 'Irvington Preparatory Academy', label: 'Irvington Preparatory Academy' },
  { value: 'Knightstown High School', label: 'Knightstown High School' },
  { value: 'Lapel High School', label: 'Lapel High School' },
  { value: 'Lawrence Central High School', label: 'Lawrence Central High School' },
  { value: 'Liberty Christian High School', label: 'Liberty Christian High School' },
  { value: 'Morristown High School', label: 'Morristown High School' },
  { value: 'Mt. Vernon High School', label: 'Mt. Vernon High School' },
  { value: 'New Castle High School', label: 'New Castle High School' },
  { value: 'New Palestine High School', label: 'New Palestine High School' },
  { value: 'North Central High School', label: 'North Central High School' },
  { value: 'Pendleton Heights High School', label: 'Pendleton Heights High School' },
  { value: 'Rushville High School', label: 'Rushville High School' },
  { value: 'Scecina High School', label: 'Scecina High School' },
  { value: 'Shenandoah High School', label: 'Shenandoah High School' },
  { value: 'St. Theodore Guerin High School', label: 'St. Theodore Guerin High School' },
  { value: 'Tri Jr-Sr High', label: 'Tri Jr-Sr High' },
  { value: 'Triton Central High School', label: 'Triton Central High School' },
  { value: 'Waldron High School', label: 'Waldron High School' },
  { value: 'Warren Central High School', label: 'Warren Central High School' },
  { value: 'Westfield High School', label: 'Westfield High School' },

  { value: 'Adult', label: 'Adult' },
  { value: 'OTHER', label: 'Other' },
];

export const PhoneTypes = [
  {
    label: 'Mobile',
    value: 'mobile',
  },
  {
    label: 'Home',
    value: 'home',
  },
  {
    label: 'Work',
    value: 'work',
  },
  {
    label: 'Fax',
    value: 'fax',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const Relations = [
  {
    label: 'Mother',
    value: 'mother',
  },
  {
    label: 'Father',
    value: 'father',
  },
  {
    label: 'Step Mother',
    value: 'step_mother',
  },
  {
    label: 'Step Father',
    value: 'step_father',
  },
  {
    label: 'Grandmother',
    value: 'grandmother',
  },
  {
    label: 'Grandfather',
    value: 'grandfather',
  },
  {
    label: 'Aunt',
    value: 'aunt',
  },
  {
    label: 'Uncle',
    value: 'uncle',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const States = [
  {
    label: 'Alabama',
    value: 'AL',
  },
  {
    label: 'Alaska',
    value: 'AK',
  },
  {
    label: 'American Samoa',
    value: 'AS',
  },
  {
    label: 'Arizona',
    value: 'AZ',
  },
  {
    label: 'Arkansas',
    value: 'AR',
  },
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Colorado',
    value: 'CO',
  },
  {
    label: 'Connecticut',
    value: 'CT',
  },
  {
    label: 'Delaware',
    value: 'DE',
  },
  {
    label: 'District Of Columbia',
    value: 'DC',
  },
  {
    label: 'Federated States Of Micronesia',
    value: 'FM',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'Georgia',
    value: 'GA',
  },
  {
    label: 'Guam',
    value: 'GU',
  },
  {
    label: 'Hawaii',
    value: 'HI',
  },
  {
    label: 'Idaho',
    value: 'ID',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
  {
    label: 'Indiana',
    value: 'IN',
  },
  {
    label: 'Iowa',
    value: 'IA',
  },
  {
    label: 'Kansas',
    value: 'KS',
  },
  {
    label: 'Kentucky',
    value: 'KY',
  },
  {
    label: 'Louisiana',
    value: 'LA',
  },
  {
    label: 'Maine',
    value: 'ME',
  },
  {
    label: 'Marshall Islands',
    value: 'MH',
  },
  {
    label: 'Maryland',
    value: 'MD',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
  },
  {
    label: 'Michigan',
    value: 'MI',
  },
  {
    label: 'Minnesota',
    value: 'MN',
  },
  {
    label: 'Mississippi',
    value: 'MS',
  },
  {
    label: 'Missouri',
    value: 'MO',
  },
  {
    label: 'Montana',
    value: 'MT',
  },
  {
    label: 'Nebraska',
    value: 'NE',
  },
  {
    label: 'Nevada',
    value: 'NV',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
  },
  {
    label: 'New Mexico',
    value: 'NM',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'North Carolina',
    value: 'NC',
  },
  {
    label: 'North Dakota',
    value: 'ND',
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    label: 'Ohio',
    value: 'OH',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
  },
  {
    label: 'Oregon',
    value: 'OR',
  },
  {
    label: 'Palau',
    value: 'PW',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
  },
  {
    label: 'Puerto Rico',
    value: 'PR',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
  },
  {
    label: 'South Carolina',
    value: 'SC',
  },
  {
    label: 'South Dakota',
    value: 'SD',
  },
  {
    label: 'Tennessee',
    value: 'TN',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Utah',
    value: 'UT',
  },
  {
    label: 'Vermont',
    value: 'VT',
  },
  {
    label: 'Virgin Islands',
    value: 'VI',
  },
  {
    label: 'Virginia',
    value: 'VA',
  },
  {
    label: 'Washington',
    value: 'WA',
  },
  {
    label: 'West Virginia',
    value: 'WV',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
  },
  {
    label: 'Wyoming',
    value: 'WY',
  },
];
